var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useState } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { useSetAtom, useAtomValue } from 'jotai';
import { Translate } from "../../../../I18N";
import ThesauriAPI from "../../../api/thesauri";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, Table, ConfirmationModal } from "../../../Components/UI";

import { Link, useLoaderData, useNavigate, useRevalidator } from 'react-router-dom';

import { notificationAtom, templatesAtom } from "../../../atoms";

import {
  EditButton,
  LabelHeader,
  ActionHeader,
  TemplateHeader,
  ThesaurusLabel,
  templatesCells } from "./components/TableComponents";


const theasauriListLoader =
(headers) =>
async () =>
ThesauriAPI.getThesauri({}, headers);

const ThesauriList = () => {
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const thesauri = useLoaderData();
  const setNotifications = useSetAtom(notificationAtom);
  const templates = useAtomValue(templatesAtom);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [tableThesauri, setTableThesauri] = useState([]);
  const [selectedThesauri, setSelectedThesauri] = useState([]);

  useEffect(() => {
    setTableThesauri(
      thesauri.map((thesaurus) => {
        const templatesUsingIt = templates.
        map((t) => {var _t$properties;
          const usingIt = (_t$properties = t.properties) === null || _t$properties === void 0 ? void 0 : _t$properties.some(
            (property) => property.content === thesaurus._id
          );
          return usingIt ? t : null;
        }).
        filter((t) => t);

        return _objectSpread(_objectSpread({},
        thesaurus), {}, {
          templates: templatesUsingIt,
          disableRowSelection: Boolean(templatesUsingIt.length) });

      })
    );
  }, [thesauri, templates]);

  const navigateToEditThesaurus = (thesaurus) => {
    navigate(`/settings/thesauri/edit/${thesaurus.original._id}`);
  };

  const deleteSelectedThesauri = async () => {
    try {
      const requests = selectedThesauri.map((sThesauri) => {
        return ThesauriAPI.delete({ _id: sThesauri.original._id });
      });
      await Promise.all(requests);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri deleted")
      });
    } catch (e) {
      setNotifications({
        type: 'error',
        text: e.message
      });
    } finally {
      revalidator.revalidate();
      setShowConfirmationModal(false);
    }
  };

  const columnHelper = createColumnHelper();
  const columns = ({ edit }) => [
  columnHelper.accessor('name', {
    id: 'name',
    header: LabelHeader,
    cell: ThesaurusLabel,
    meta: { headerClassName: 'w-6/12 font-medium' }
  }),
  columnHelper.accessor('templates', {
    header: TemplateHeader,
    cell: templatesCells,
    enableSorting: false,
    meta: { headerClassName: 'w-6/12' }
  }),
  columnHelper.accessor('_id', {
    header: ActionHeader,
    cell: EditButton,
    enableSorting: false,
    meta: { action: edit, headerClassName: 'w-0 text-center sr-only' }
  })];


  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-thesauri" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Thesauri" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "thesauri" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      enableSelection: true,
      columns: columns({ edit: navigateToEditThesaurus }),
      data: tableThesauri,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesauri"),
      initialState: { sorting: [{ id: 'name', desc: false }] },
      onSelection: setSelectedThesauri }
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "bg-indigo-50", highlighted: true }, void 0,
    selectedThesauri.length ? /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: () => setShowConfirmationModal(true),
      color: "error",
      "data-testid": "menu-delete-link" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedThesauri.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"), ' ',
    thesauri.length
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Link, { to: "/settings/thesauri/new" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add thesaurus")
    )
    )
    )
    )

    )
    ),
    showConfirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      size: "lg",
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Are you sure you want to delete this item?"),
      body: /*#__PURE__*/
      _jsx("ul", { className: "flex flex-wrap gap-8 max-w-md list-disc list-inside" }, void 0,
      selectedThesauri.map((item) => /*#__PURE__*/
      _jsx("li", {}, item.original.name, item.original.name)
      )
      ),

      onAcceptClick: deleteSelectedThesauri,
      onCancelClick: () => setShowConfirmationModal(false),
      dangerStyle: true }
    )

    ));

};

export { ThesauriList, theasauriListLoader };